<!-- =========================================================================================
  File Name: UserEditTabInformation.vue
  Description: User Edit Information Tab content
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div class="vx-row p-4">
		<div class="vx-col w-full">
			<ul class="ul-area">
				<li class="mt-3">
					<vs-radio v-model="status" vs-value="frequencyDayWeek">{{ $t("TimeWindow.EveryDay") }}</vs-radio>
				</li>
				<li class="mt-4">
					<div class="vx-row">
						<div class="vx-col w-full">
							<vs-radio v-model="status" vs-value="rangeDayWeek">
								<div class="form-inline">
									<span>{{ $t("TimeWindow.Every") }} </span>
									<vs-select
										autocomplete
										v-model="numberDayWeek"
										width="50px"
										class="ml-1"
										:disabled="status !== 'rangeDayWeek'"
										:input-changed="getResultDayWeek"
									>
										<vs-select-item
											:key="index"
											:value="option.value"
											:text="option.text"
											v-for="(option, index) in dayList"
										/>
									</vs-select>
									<span class="ml-1"
										>{{ ($t("TimeWindow.Day") + " ") | lowerCase
										}}{{
											($t("TimeWindow.FromThe") + " " + $t("TimeWindow.Day")) | lowerCase
										}}</span
									>
									<vs-select
										autocomplete
										v-model="numberDay"
										width="120px"
										class="ml-1"
										:disabled="status !== 'rangeDayWeek'"
										:input-changed="getResultDayWeek"
									>
										<vs-select-item
											:key="index"
											:value="option.code"
											:text="option.text"
											v-for="(option, index) in nameDayWeek"
										/>
									</vs-select>
								</div>
							</vs-radio>
						</div>
					</div>
				</li>
				<li class="mt-4">
					<div class="vx-row">
						<div class="vx-col w-full">
							<vs-radio v-model="status" vs-value="choiceDayWeek">{{
								$t("TimeWindow.SpecificDayOfTheWeek")
							}}</vs-radio>
							<div class="vx-row">
								<div class="vx-col w-full">
									<vs-select
										autocomplete
										multiple
										v-model="selectDayWeek"
										width="100%"
										:disabled="status !== 'choiceDayWeek'"
										:input-changed="getResultDayWeek"
									>
										<vs-select-item
											:key="index"
											:value="option.value"
											:text="option.text"
											v-for="(option, index) in nameDayWeek"
										/>
									</vs-select>
								</div>
							</div>
						</div>
					</div>
				</li>
				<li class="mt-4">
					<div class="vx-row">
						<div class="vx-col w-full">
							<vs-radio v-model="status" vs-value="betweenDayWeek">
								<div class="form-inline">
									<span>{{ $t("TimeWindow.EveryDayBetween") }} </span>
									<vs-select
										autocomplete
										v-model="numbeRangeInit"
										width="120px"
										class="ml-1"
										:disabled="status !== 'betweenDayWeek'"
										:input-changed="getResultDayWeek"
									>
										<vs-select-item
											:key="index"
											:value="option.code"
											:text="option.text"
											v-for="(option, index) in nameDayWeek"
										/>
									</vs-select>
									<span class="ml-1">{{ ($t("TimeWindow.And") + " ") | lowerCase }}</span>
									<vs-select
										autocomplete
										v-model="numbeRangeEnd"
										width="120px"
										class="ml-1"
										:disabled="status !== 'betweenDayWeek'"
										:input-changed="getResultDayWeek"
									>
										<vs-select-item
											:key="index"
											:value="option.code"
											:text="option.text"
											v-for="(option, index) in nameDayWeek"
										/>
									</vs-select>
								</div>
							</vs-radio>
						</div>
					</div>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
export default {
	name: "DayWeek",
	data() {
		return {
			status: "frequencyDayWeek",
			numberDayWeek: 1,
			everyNumber: 1,
			numberDay: 1,
			numbeRangeInit: 1,
			numbeRangeEnd: 1,
			selectDayWeek: ["MON"],
			nameDayWeek: [
				{text: this.$t("TimeWindow.NameWeek.Monday"), value: "MON", code: 1},
				{text: this.$t("TimeWindow.NameWeek.Tuesday"), value: "TUE", code: 2},
				{text: this.$t("TimeWindow.NameWeek.Wednesday"), value: "WED", code: 3},
				{text: this.$t("TimeWindow.NameWeek.Thursday"), value: "THU", code: 4},
				{text: this.$t("TimeWindow.NameWeek.Friday"), value: "FRI", code: 5},
				{text: this.$t("TimeWindow.NameWeek.Saturday"), value: "SAT", code: 6},
				{text: this.$t("TimeWindow.NameWeek.Sunday"), value: "SUN", code: 7},
			],
		};
	},
	props: {
		cronExpressionDayWeek: {
			type: String,
			default: "",
		},
		isEdit: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		getResultDayWeek() {
			let result = "";
			switch (this.status) {
				case "frequencyDayWeek":
					result = "*";
					break;
				case "rangeDayWeek":
					result = `${this.numberDay}/${this.numberDayWeek}`;
					break;
				case "choiceDayWeek":
					result = `${this.selectDayWeek.join(",")}`;
					break;
				case "betweenDayWeek":
					result = `${this.numbeRangeInit}-${this.numbeRangeEnd}`;
					break;
			}
			this.$emit("resultDayWeekEmit", result);
			return result;
		},
		dayList() {
			let day = [];
			for (let i = 1; i <= 7; i++) {
				day.push({text: i, value: i});
			}
			return day;
		},
		numberList() {
			let number = [];
			for (let i = 1; i < 60; i++) {
				number.push({text: i, value: i});
			}
			return number;
		},
	},
	mounted() {
		if (
			this.cronExpressionDayWeek !== " " &&
			this.cronExpressionDayWeek !== null &&
			this.cronExpressionDayWeek !== undefined &&
			this.isEdit
		) {
			if (this.cronExpressionDayWeek.includes("*")) {
				this.status = "frequencyDayWeek";
			} else if (this.cronExpressionDayWeek.includes("/")) {
				this.numberDayWeek = this.cronExpressionDayWeek.split("/")[0];
				this.numberDay = this.cronExpressionDayWeek.split("/")[1];
				this.status = "rangeDayWeek";
			} else if (this.cronExpressionDayWeek.includes("-")) {
				this.numbeRangeInit = this.cronExpressionDayWeek.split("-")[0];
				this.numbeRangeEnd = this.cronExpressionDayWeek.split("-")[1];
				this.status = "betweenDayWeek";
			} else {
				if (this.cronExpressionDayWeek.includes(",")) {
					this.selectDayWeek = this.cronExpressionDayWeek.split(",");
				} else {
					this.selectDayWeek = [this.cronExpressionDayWeek];
				}
				this.status = "choiceDayWeek";
			}
		}
	},
};
</script>
<style lang="scss">
.form-inline {
	display: -ms-flexbox;
	display: flex;
	-ms-flex-flow: row wrap;
	flex-flow: row wrap;
	-ms-flex-align: center;
	align-items: center;
}
.specific-check {
	display: flex;
	flex-wrap: wrap;
	padding-left: 20px;
}
.check-week {
	padding: 10px 0px 10px 0px;
}
.vs-radio--input + .vs-radio + .vs-radio--label {
	color: #ababab;
	cursor: pointer;
}
.vs-radio--input:checked + .vs-radio + .vs-radio--label {
	color: #000;
}
</style>
